import Actions               from 'Redux/Actions';
import { AppUserRepository, TAppUserOrganisation } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from }              from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';

export const findAppUserOrganisationsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findAppUserOrganisationsRequest.type),
    mergeMap(action => from(
      AppUserRepository.findOrganisations(action.payload)
        .then(({ organisations }: { organisations: TAppUserOrganisation[] }) => Actions.findAppUserOrganisationsSuccess({ organisations }))
        .catch((error: Error) => Actions.findAppUserOrganisationsFailure({ error })),
    )),
  );
};
